import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useState, useEffect } from 'react';

export default function RubyPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigateToAbout = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
      <Navigation scrolled={scrolled} />
      
      <div className="pt-32 pb-20 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Back button */}
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={navigateToAbout}
            className="flex items-center gap-2 text-gray-600 hover:text-teal-500 transition-colors mb-8 group"
          >
            <i className="ri-arrow-left-line text-2xl group-hover:-translate-x-1 transition-transform"></i>
            <span className="font-semibold">Back to Home</span>
          </motion.button>

          {/* Profile Section with Wrapped Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-12"
          >
            {/* Profile Image - Float Left */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              className="relative float-left mr-8 mb-6 w-80"
            >
              <div className="w-full h-[400px] rounded-[48px] overflow-hidden border-8 border-teal-500 shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/631821f386b34ef1da569fb8b8560804/452c66b1ae4903d7c0936d1443cd6f3f.png"
                  alt="Ruby"
                  className="w-full h-full object-cover object-[center_30%]"
                />
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-teal-400 rounded-full opacity-20 blur-2xl"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-pink-400 rounded-full opacity-20 blur-2xl"></div>
            </motion.div>

            {/* Profile Info - Wraps around image */}
            <div className="space-y-6">
              <div>
                <h1 className="text-6xl font-black text-teal-500 mb-2" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                  Ruby
                </h1>
                <p className="text-2xl font-bold text-gray-700">Co-Founder</p>
              </div>

              <div className="space-y-4 text-lg text-gray-700">
                <p className="leading-relaxed">
                  Hi! I'm Ruby, co-founder of <strong className="text-teal-500">Can-do Crew</strong>. I'm passionate about my family, friends, school, and my stuffed bunny, "Fluffy."
                </p>

                <p className="leading-relaxed">
                  I love science, music, art, physical education and recess. Wolfie and I make a great team – he brings the energy, and I bring the support!! Together, we're unstoppable.When I'm not cleaning trash cans, I like to play outside, play with my bunny, cuddle with Butternut (my dog), and spend time with Mom and Dad.&nbsp;
                </p>

                <p className="leading-relaxed">
                  The best part about running this business is knowing we're <span className="font-bold text-green-500">helping others</span> in our community while learning important skills that will help us in the future!
                </p>
              </div>

              {/* Skills */}
              <div className="flex flex-wrap gap-3 clear-left">
                <span className="px-4 py-2 bg-teal-100 text-teal-600 rounded-full font-semibold text-sm">Creative Thinker</span>
                <span className="px-4 py-2 bg-green-100 text-green-600 rounded-full font-semibold text-sm">Animal Lover</span>
                <span className="px-4 py-2 bg-pink-100 text-pink-600 rounded-full font-semibold text-sm">Tender-Hearted</span>
                <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-full font-semibold text-sm">Helpful</span>
              </div>

              {/* Meet Wolfie Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/wolfie')}
                className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-heart-fill text-2xl"></i>
                Meet My Partner Wolfie!
              </motion.button>
            </div>
          </motion.div>

          {/* Two Boxes Side by Side */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Fiscal Responsibility Box */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border-4 border-teal-200">
              <h3 className="text-2xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                We are learning fiscal responsibility
              </h3>
              <p className="text-lg font-semibold text-gray-700 mb-4">With the income we earn, we put:</p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700"><strong className="text-teal-500">10% to giving</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700"><strong className="text-teal-500">10% to saving</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700"><strong className="text-teal-500">10% to investing</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700">My big savings goal: <strong className="text-teal-500">Trip to visit friends in France</strong></span>
                </li>
              </ul>
            </div>

            {/* Fun Facts Box */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border-4 border-teal-200">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                Fun Facts About Me
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700">Favorite Color: <strong className="text-teal-500">Teal</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700">Favorite Subject: <strong className="text-teal-500">Science</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700">Superpower: <strong className="text-teal-500">Helping others</strong></span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl flex-shrink-0"></i>
                  <span className="text-gray-700">Dream: <strong className="text-teal-500">Climb a tree all the way to the top</strong></span>
                </li>
              </ul>
            </div>
          </div>

          {/* Gallery Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-20"
          >
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-12" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
              Ruby in Action!
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="rounded-3xl overflow-hidden shadow-lg border-4 border-teal-200 h-64">
                <img
                  src="https://public.readdy.ai/ai/img_res/9ba941c702a67b8256efa2482195cb1f.jpg"
                  alt="Ruby cleaning"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="rounded-3xl overflow-hidden shadow-lg border-4 border-teal-200 h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=young%20girl%20in%20teal%20cap%20giving%20thumbs%20up%20next%20to%20sparkling%20clean%20green%20trash%20bin%2C%20proud%20smiling%20face%2C%20suburban%20house%20background%2C%20bright%20sunny%20day%2C%20professional%20kid-friendly%20service%20aesthetic%20with%20primary%20colors%2C%20clean%20simple%20background%20showcasing%20achievement%20and%20environmental%20success&width=400&height=400&seq=ruby2&orientation=squarish"
                  alt="Ruby with clean bin"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="rounded-3xl overflow-hidden shadow-lg border-4 border-teal-200 h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=young%20girl%20wearing%20teal%20cap%20and%20colorful%20t-shirt%20holding%20eco-friendly%20cleaning%20supplies%20and%20brushes%2C%20standing%20confidently%20in%20front%20of%20neighborhood%20street%2C%20happy%20energetic%20expression%2C%20professional%20cleaning%20crew%20photo%20with%20bright%20cheerful%20atmosphere%2C%20simple%20clean%20suburban%20background%20showing%20leadership%20and%20environmental%20responsibility&width=400&height=400&seq=ruby3&orientation=squarish"
                  alt="Ruby with equipment"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
